import React from "react";

export default function SalaryStructureTable({
  structures,
  onEdit,
  onDelete,
}) {
  return (
    <div className="finance-table-card">
      <table className="finance-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Structure Name</th>
            <th>Department</th>
            <th>Description</th>
            <th>Components</th>
            <th>Status</th>
            <th style={{ textAlign: "center" }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {structures.length === 0 ? (
            <tr>
              <td
                colSpan="7"
                style={{
                  textAlign: "center",
                  padding: "30px",
                  color: "#888",
                }}
              >
                No salary structures found.
              </td>
            </tr>
          ) : (
            structures.map((structure, index) => (
              <tr key={structure.id}>
                <td>{index + 1}</td>

                <td>{structure.structureName}</td>

                <td>{structure.department}</td>

                <td>{structure.description}</td>

                <td>
                  <span className="component-count-badge">
                    {structure.components.length} Components
                  </span>
                </td>

                <td>
                  <span
                    className={
                      structure.status === "Active"
                        ? "status-active"
                        : "status-inactive"
                    }
                  >
                    {structure.status}
                  </span>
                </td>

                <td className="finance-action-cell">
                  <button
                    className="edit-btn"
                    onClick={() => onEdit(structure)}
                  >
                    Edit
                  </button>

                  <button
                    className="delete-btn"
                    onClick={() => onDelete(structure.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}